import { ChevronLeft } from "lucide-react";

export const Header = ({ showBack, onBack }) => {
  return (
    <header className="relative flex flex-col items-center pt-7 pb-4" data-testid="app-header">
      {showBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Indietro"
          data-testid="back-button"
          className="absolute left-0 top-6 flex h-10 w-10 items-center justify-center rounded-full text-ink/60 transition-colors hover:bg-ink/5 hover:text-ink"
        >
          <ChevronLeft size={24} strokeWidth={2.2} />
        </button>
      )}
      <h1 className="font-serif text-xl font-semibold uppercase tracking-[0.32em] text-ink">
        Leggera Flow
      </h1>
      <p className="mt-1 text-xs font-light tracking-wide text-ink/55">
        Gonfiore · Circolazione · Postura
      </p>
    </header>
  );
};
